<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Schools</h5>
        </div>
        <div class="col-6 col-sm-4 text-right">
          <add-school @created="handleCreated"/>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-xl-12">
          <div class="text-right mb-3">
            <a-input-search placeholder="Search School" size="large" style="width: 300px" @search="onSearch" />
          </div>
        <div class="card">
          <div class="card-body">
            <schools-table :data="data" :loading="loading" @updateTable="handleUpdateTable" />
          </div>
        </div>
        <div class="text-right">
          <a-pagination
              showSizeChanger
              @showSizeChange="onShowSizeChange"
              :total="meta.total"
              :pageSize.sync="pageSize"
              v-model="current"
              @change="onChange"
            >
          </a-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SchoolsTable from '@/components/school/Table/index'
import AddSchool from '@/components/school/Forms/Add/index'

export default {
  components: {
    SchoolsTable,
    AddSchool,
  },
  mounted: function() {
    this.getSchools()
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      data: [],
      meta: {},
      current: 1,
      pageSize: 10,
    }
  },
  // watch: {
  //   pageSize(val) {
  //     console.log('pageSize', val)
  //   },
  //   current(val) {
  //     console.log('current', val)
  //   },
  // },
  methods: {
    getSchools: function() {
      this.loading = true
      this.$http.get('/api/school', {
        params: {
          limit: this.pageSize,
          page: this.current,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data.meta
      })
    },
    onSearch(value) {
      console.log(value)
    },
    handleCreated: function() {
      this.getSchools()
    },
    handleUpdateTable: function() {
      this.getSchools()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getSchools()
    },
    onChange(current) {
      this.current = current
      this.getSchools()
    },
  },
}
</script>
